import { FC, useEffect } from 'react';
import { XMarkIcon as CloseIcon } from '@heroicons/react/24/solid';
import ReactModal, { Props as ReactModalProps } from 'react-modal';
import useMediaQuery from '@loomstateorg/shared-frontend/hooks/useMediaQuery';
//import useScrollBlock from '@loomstateorg/shared-frontend/hooks/useScrollBlock';
import { desktop } from '@loomstateorg/shared-frontend/utils/screensizes';

export interface Props extends ReactModalProps {
  closeButton?: boolean;
}

const Modal: FC<Props> = ({ children, style, preventScroll, closeButton, className = '', ...props }) => {
  const [isDesktopSize] = useMediaQuery(desktop);

  //const { blockScroll } = useScrollBlock();

  const modalStyle: ReactModalProps['style'] = {
    overlay: {
      zIndex: 51,
      backgroundColor: 'rgba(127 ,127, 127, .3)',
      ...style?.overlay,
    },
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(-50%, -50%)',
      maxWidth: isDesktopSize ? 800 : '100%',
      position: 'relative',
      padding: 0,
      ...style?.content,
    },
  };

  useEffect(() => {
    if (preventScroll) document.body.style.overflow = props.isOpen ? 'hidden' : 'auto';
  }, [props.isOpen, preventScroll]);
  /*
  useEffect(() => {
    blockScroll(props.isOpen);
  }, [props.isOpen, blockScroll]);*/

  return (
    <ReactModal
      {...props}
      ariaHideApp={false}
      style={modalStyle}
      preventScroll={preventScroll}
      className={`${className} relative bg-site`}
      data-testid="atom-modal"
    >
      {closeButton && (
        <button
          type="button"
          className="absolute right-20 top-20 cursor-pointer bg-transparent p-0 border-0"
          onClick={props.onRequestClose}
          aria-label="Close modal"
          data-testid="atom-modal-close-button"
        >
          <CloseIcon
            className="size-24 text-primary-regular"
            aria-hidden="true"
          />
        </button>
      )}
      {children}
    </ReactModal>
  );
};

export default Modal;
